import React, { useEffect, useState } from 'react';

import { column } from '@/config/uploadSongTable.config';
import {
  AppSkeleton,
  SongsDetailsPopup,
  Table,
  // UploadDocumentPopup,
  UploadDocumentPopup2,
  UploadMusicDonePopup,
  UploadMusicPopup,
} from '@/component';
import { Button } from '@/kaya';
import { songsStore, uploadMusicStore } from '@/store';
import Icons from '@/icons';
import { iconConstants } from '@/constants';

import styles from './UploadMusic.module.scss';

const UploadMusic = () => {
  const { setFormValues, formvalues, setIsUploadDone, isUploadDone } = uploadMusicStore();
  const { songs } = songsStore();

  const [isUpload, setIsUpload] = useState(false);
  const [isSongsDetails, setIsSongsDetails] = useState(false);
  // const [isUploadDocument, setIsUploadDocument] = useState(false);
  const [isUploadDocument2, setIsUploadDocument2] = useState(false);
  const [errors, setErrors] = useState<{
    [key: string]: string;
  }>({});

  const handleChange =
    (id: string | object) => (val: string | number | boolean | object | File | Date | null) => {
    if (typeof id !== 'object') {
      setFormValues({
        ...formvalues,
        [id]: val,
      });

      setErrors({
        ...errors,
        [id]: '',
      });
    } else {
      setFormValues({
        ...formvalues,
        ...id,
      });
    }
    // setFormValues({ ...formvalues, [id]: val });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const signParam = urlParams.get('sign');

    if (signParam === 'successfull') {
      setIsUploadDone(true);

      window.history.replaceState({}, document.title, window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppSkeleton>
      <div className={styles.header}>
        <p className={styles.UploadMusic}>Upload Music</p>
        <Button
          type="Primary"
          onClick={() => {
            setIsUpload(true);
          }}
          width="167px"
          prefixIcon={<Icons type={iconConstants.ICONS.ADD_ICON} />}
        >
          Upload Songs
        </Button>
      </div>
      <div style={{ height: 'calc(100vh - 160px)' }}>
        <Table columns={column} rows={songs} disableActions />
      </div>

      {isUpload && (
        <UploadMusicPopup
          visible={isUpload}
          setVisible={setIsUpload}
          title="Upload your Music"
          description="Drag and Drop audio files to upload"
          description2="Your music will be private until you publish them."
          btnText="Select Files"
          // formvalues={formvalues}
          handleChange={handleChange}
          setIsSongsDetails={setIsSongsDetails}
        />
      )}
      {isSongsDetails && (
        <SongsDetailsPopup
          visible={isSongsDetails}
          setVisible={setIsSongsDetails}
          handleChange={handleChange}
          setIsUploadDocument2={setIsUploadDocument2}
          formvalues={formvalues}
          setErrors={setErrors}
          errors={errors}
        />
      )}

      {/* {isUploadDocument && (
        <UploadDocumentPopup
          visible={isUploadDocument}
          setVisible={setIsUploadDocument}
          title="Documents"
          description="Upload the licensing document"
          // description2="Don’t have document? Download from here"
          btnText="Next"
          handleChange={handleChange}
          setIsUploadDocument2={setIsUploadDocument2}
        />
      )} */}

      {isUploadDocument2 && (
        <UploadDocumentPopup2
          visible={isUploadDocument2}
          setVisible={setIsUploadDocument2}
          btnText="Next"
          handleChange={handleChange}
          onBack={() => {
            setIsUploadDocument2(false);
            setIsSongsDetails(true);
          }}
        />
      )}

      {isUploadDone && <UploadMusicDonePopup visible={isUploadDone} setVisible={setIsUploadDone} />}
    </AppSkeleton>
  );
};

export default UploadMusic;
